import { Button, Icon, Loader, Modal } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect } from 'react'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutToken, useIsApplePaylater, useLazyGetCheckoutPpaDocumentQuery } from '../../state'
import styles from './style.module.css'

interface ContractModalProps {
  showContractModal: boolean
  onClose: () => void
  docId?: string
}

export const ApprovedCreditContractModal: FunctionComponent<ContractModalProps> = ({ showContractModal, onClose, docId }) => {
  const { t } = useTranslation()
  const token = useCheckoutToken()
  const isApplePaylater = useIsApplePaylater()

  const [getDocument, { data: documentData, isFetching: isDocumentLoading }] = useLazyGetCheckoutPpaDocumentQuery()

  const printDocument = (): void => {
    const documentIframe: HTMLIFrameElement | null = document.querySelector('#contract-iframe')
    documentIframe?.contentWindow?.print()
  }

  useEffect(() => {
    if (token && docId) {
      getDocument({ token, docId })
    }
  }, [token, docId])

  return (
    <Modal show={showContractModal} onClose={onClose} showCloseButton={showContractModal}>
      {!isApplePaylater && (
        <div className={styles.contractModalHeader}>
          <Button.Link
            testNameSpace='print-contract'
            type='button'
            aria-label='print-facility-contract-button'
            onClick={printDocument}
            disabled={isDocumentLoading}
          >
            <Icon.Printer size='Medium' color='Black' />
          </Button.Link>
        </div>
      )}
      {isDocumentLoading ? (
        <Loader testNameSpace='contract-modal' />
      ) : (
        <iframe
          data-testid='contract-iframe'
          id='contract-iframe'
          className={styles.documentIframe}
          srcDoc={documentData?.renderedHtml}
          title={t('common:iframeTitleContractDocument')}
        />
      )}
    </Modal>
  )
}
